import builder from '../builder';
import SearchAlternate from '../../streamline-icons/bold/search-alternate.svg';

export default builder('IconSearchAlternateBold', SearchAlternate);
